module.exports = __webpack_public_path__ + "d940e3ea2a3e418c757adcb9413d18a8.svg";